exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media print {\n  .Ads__topAds___1qtGI, .Ads__rightAds____FDT0, .Ads__bottomAds___voxWc {\n    display: none; } }\n\n@media screen and (max-width: 1340px) {\n  .Ads__rightAds____FDT0 {\n    display: none; } }\n\n.Ads__rightAds____FDT0 iframe {\n  margin: 0; }\n", ""]);

// exports
exports.locals = {
	"topAds": "Ads__topAds___1qtGI",
	"rightAds": "Ads__rightAds____FDT0",
	"bottomAds": "Ads__bottomAds___voxWc"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/containers/AdDetailsPage/AdDetailsPageWeb/styles/Ads.scss
// module id = 4574
// module chunks = 6